// en, de, fr, pt
export default {
	en: JSON.parse(localStorage.getItem("dictionary_en")) || {},
	ru: JSON.parse(localStorage.getItem("dictionary_ru")) || {}
}
